import { getAssetSrc } from '../utils/assets';
/**
 * Mapping of payment provider brand names (lowercase) to their logo SVG paths.
 * Used across payment-related components (company cards, payment method lists, add payment form).
 */

export var paymentProviderLogoMap = {
  mastercard: getAssetSrc('/utils-assets/mastercard.svg'),
  visa: getAssetSrc('/utils-assets/visa.svg'),
  maestro: getAssetSrc('/utils-assets/maestro.svg'),
  amex: getAssetSrc('/utils-assets/amex.svg')
};
/**
 * Array format of payment logos with alt text, used for displaying all accepted providers.
 */

export var paymentLogos = [{
  src: paymentProviderLogoMap.visa,
  alt: 'Visa'
}, {
  src: paymentProviderLogoMap.mastercard,
  alt: 'Mastercard'
}, {
  src: paymentProviderLogoMap.maestro,
  alt: 'Maestro'
}, {
  src: paymentProviderLogoMap.amex,
  alt: 'Amex'
}];